import { Component, OnInit, OnDestroy, Input, SimpleChanges, OnChanges} from '@angular/core';
import { Partner } from '../../models/partner';
import { PartnerRelationship } from '../../models/PartnerRelationship';
import { Subscription } from 'rxjs';
import { ConfirmationService, Message } from 'primeng/api';
import { PartnerService } from '../../partner-service';
import { PartnershipService } from '../../partnership.service';
import { GlobalNamespace as _GlobalNS } from '../../../../environments/environment';

@Component({
  selector: 'app-partnership-list',
  templateUrl: './partnership-list.component.html',
  styleUrls: ['./partnership-list.component.scss'],
  providers: [ConfirmationService]
})
export class PartnershipListComponent implements OnInit, OnDestroy, OnChanges {

  partners: PartnerRelationship[];
  partnerList: Partner[];
  partnerUser: Partner;
  partnerRelationship: PartnerRelationship;
  relationshipId: number;
  displayDialog = false;
  subscription: Subscription;
  @Input() messages: Message[];
  loading = false;
  @Input() relationships: PartnerRelationship[];
  partnerDetailsUri: string;

  constructor(private partnerSvc: PartnerService,
      private confirmationService: ConfirmationService,
      private partnershipSvc: PartnershipService ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.relationships && changes.relationships.currentValue) {
      this.partners = changes.relationships.currentValue;
      this.populatePartnershipGrid();
      this.messages = [{severity: 'success', summary: 'Partnership Successfully Added', detail: ''}];
    }
  }

  ngOnInit() {
    this.getAllRelationships();
    this.partnerDetailsUri = (<any>_GlobalNS).routes.person.PartnerDetails;
  }

  getAllRelationships(): void {
    this.loading = true;
    this.subscription = this.partnershipSvc.find()
      .subscribe(partners  => {
      this.partners = (<any>partners).data;
      this.loading = false;
      this.populatePartnershipGrid();
    });
  }

  populatePartnershipGrid(): void {
    this.partnerList = this.partners.map( (partner: PartnerRelationship) => {
      return <Partner> this.getPartnerObj(partner);
    });
  }

  getPartnerObj(partner: PartnerRelationship): Partner {
    const list = { 'RelationshipXrefId': partner.RelationshipId,
    'PersonId': partner.PartnerUser[0].Person.PersonId,
        'IsActive': partner.IsActive,
        'RelationshipType': partner.RelationshipType.Description,
        'CompanyName': partner.ChildCompany.Name,
        'UserCount': partner.UserCount,
        'PrimaryContact': partner.PartnerUser[0].Person.FirstName ?
        partner.PartnerUser[0].Person.LastName + ', ' + partner.PartnerUser[0].Person.FirstName  : '',
        'Phone': partner.PartnerUser[0].Person.Phone ? partner.PartnerUser[0].Person.Phone : '',
        'Email': partner.PartnerUser[0].Person.Email};
      return <Partner> list;
  }

  dialogClose(bDialog: boolean): void {
    this.displayDialog = bDialog;
  }

  editPartner(PartnerUser: Partner): void {
    this.relationshipId = PartnerUser.RelationshipXrefId;
    this.partnerUser = PartnerUser;
    this.displayDialog = true;
  }

  deactivatePartnerConfirm(partnerUser: Partner): void {
    const message = `Are you sure you want to Inactivate the Partnership: ${partnerUser.CompanyName}.
      You will also be removing access to your properties/loans for ${String(partnerUser.UserCount)} users`;
    this.confirmationService.confirm({
        message: message,
        accept: () => {
          this.loading = true;
          this.messages = [{severity: 'info', summary: 'Processing Delete', detail: ''}];
          this.deactivatePartner(partnerUser);
        }
    });
  }

  deactivatePartner(partnerUser: Partner): void {
    this.subscription = this.partnerSvc.deactivate(partnerUser.RelationshipXrefId, partnerUser.PersonId)
      .subscribe(partners  => {
      this.partners = partners['data'];
      this.populatePartnershipGrid();
      this.loading = false;
      this.messages = [{severity: 'info', summary: 'Inactivated: ', detail: `Successfully Inactivated Partnership
       ${partnerUser.CompanyName}`}];
    });
  }

  refreshRelationships(relationships: PartnerRelationship[]): void {
    this.partners = relationships;
    this.populatePartnershipGrid();
    this.messages = [{severity: 'success', summary: 'Partnership Successfully Updated', detail: ''}];
  }

  errorMessage(message: string) {
    this.messages = [{severity: 'error', summary: message, detail: ''}];
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
